module.exports = __webpack_public_path__ + "static/media/historia3.c03bfcc6.png";